(() => {
  if (document.querySelector('.nekoan-privacy-backdrop')) return;
  const backdrop = document.createElement('div');
  backdrop.className = 'nekoan-privacy-backdrop';
  backdrop.hidden = true;
  backdrop.setAttribute('aria-hidden', 'true');
  document.body.append(backdrop);
  let frame = 0;
  const visible = element => Boolean(element && element.getClientRects().length && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
  const sync = () => {
    frame = 0;
    const open = visible(document.getElementById('shopify-pc__banner'));
    const preferencesOpen = visible(document.getElementById('shopify-pc__prefs__dialog'));
    const showBackdrop = open && !preferencesOpen;
    if (backdrop.hidden === showBackdrop) backdrop.hidden = !showBackdrop;
    const lockScroll = open || preferencesOpen;
    if (document.body.classList.contains('nekoan-privacy-open') !== lockScroll) {
      document.body.classList.toggle('nekoan-privacy-open', lockScroll);
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const privacyNode = node => node.nodeType === 1 && (node.id?.startsWith('shopify-pc__') || node.querySelector?.('[id^="shopify-pc__"]'));
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes'
      ? record.target.id?.startsWith('shopify-pc__') || record.target.closest?.('[id^="shopify-pc__"]')
      : (record.target.id?.startsWith('shopify-pc__') || record.target.closest?.('[id^="shopify-pc__"]')) || [...record.addedNodes, ...record.removedNodes].some(privacyNode))) schedule();
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'aria-hidden', 'class']});
  document.addEventListener('click', event => {
    const link = event.target.closest('.nekoan-cookie-settings a[href="#shopifyReshowConsentBanner"]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.privacyBanner.showPreferences().then(schedule).catch(() => {
      location.hash = '';
      location.hash = 'shopifyReshowConsentBanner';
    });
  }, true);
  document.addEventListener('visitorConsentCollected', schedule);
  sync();
})();
